import React, { useEffect } from 'react';
import './index.scss';
import LoginHeader from './header/header.js';
import LoginMain from './main/main.js';
import LoginFooter from './footer/footer.js';
import Aedviser from '../../../components/aedviser'

function Index() {
  return (
    <section className="login-root">
      <div className="main-wrapper">
        <LoginHeader />
        <LoginMain />
      </div>
      <LoginFooter />
      <Aedviser />
    </section>
  );
}

export default Index;
